import { toast } from "react-toastify";
// import moment from "moment";
import moment from "moment-timezone";
import RenderInlineNotification from "components/RenderInlineNotification";
import BackendApi from "../api/backendApi";

// tips

export const toastTips = (msg, kind = "info", containId = "main") => {
  toast(<RenderInlineNotification message={msg} type={kind} />, {
    containerId: containId,
  });
};

// 防抖
let timer = null;
export const debounce = (fn, delay = 1000) => {
  return function() {
    if (timer !== null) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
};
// 节流
export const throttle = (fn, delay = 1000) => {
  let valid = true;
  return function() {
    if (valid) {
      setTimeout(() => {
        fn.apply(this, arguments);
        valid = true;
      }, delay);
      valid = false;
    }
  };
};

// 解析token,获取用户信息
export const parseToken = (token) => {
  if (!token) return;
  let strings = token.split(".");
  var userinfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/"))))); //解析，需要吧‘_’,'-'进行转换否则会无法解析
  return userinfo;
};

// 复制文本
export const copyText = (text) => {
  const textDecorate = "{" + text + "}";
  if (window.isSecureContext) {
    navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
      console.log(result);
      if (result.state === "granted" || result.state === "prompt") {
        /* write to the clipboard now */
      }
    });

    navigator.clipboard.writeText(textDecorate).then(
      () => {
        // console.log("copy success");
      },
      () => {
        console.log("copy fail");
      },
    );
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = textDecorate;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
};

// date format ex 2020-01-01

export const dateFormatBar = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

// export const dateDDMMYYYY = (date) => {
//   return moment(date).format("DD-MM-YYYY");
// };
export const dateFormatMMM = (date) => {
  return moment(date).format("DD-MMM-YY");
};

export const dateFormatYMD = (date) => {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};

export const dateFormatMelYMD = (date) => {
  return moment(date)
    .tz("Australia/Melbourne")
    .format("YYYY-MM-DD HH:mm:ss");
};

// date format YYYY-MM-DD->new Date()
export const standardDateFormat = (date) => {
  console.log(new Date(date));

  return new Date(date);
  const dateTmp = moment.utc(date).format();
  console.log(dateTmp);
  return dateTmp;
};

export const ddMMyyyyToDate = (date) => {
  return moment(date, "DD-MM-YYY").format();
};

//prohibit/allow scroll
export const toggleScroll = (flag) => {
  if (flag) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
};

//depp clone
export const deepClone = (obj) => {
  let _obj = JSON.stringify(obj),
    objClone = JSON.parse(_obj);
  return objClone;
};

// 数组添加id
export const addDataIsSelect = (data) => {
  data.forEach((item, index) => {
    item.id = index;
    item.isSelected = false;
  });
  return data;
};

//状态处理
export const dealStatus = (active) => {
  if (active == 1) {
    return "Active";
  } else {
    return "Inactive";
  }
};

//把key =label 换成key = text
export const replaceFilterObj = (data) => {
  return data.map((item) => {
    return {
      text: item.label,
      value: item.value,
    };
  });
};

export const checkUserAuthStatus = async (authStatusQueryData) => {
  try {
    let authStatusRes = await BackendApi.checkAuthStatus(authStatusQueryData);
    console.log("Response from checkUserAuthStatus api request:", authStatusRes);

    if (!!authStatusRes && authStatusRes.code == 200 && !!authStatusRes.data) {
      return authStatusRes.data;
    }
  } catch (error) {
    console.error("Error making checkUserAuthStatus api request:", error);
  }
};
//auth
export const checkRole = (role) => {
  return role === "admin";
};
//返回June 11, 10:00 AM 格式
export const getDateFormat = (timeStamp, timeZone) => {
  return moment
    .unix(timeStamp)
    .tz(timeZone)
    .format("MMMM DD, h:mm A");
};
